<div class="cookies-notification-banner-container">
  <div class="cookies-notification-banner-notice" data-hook="cookies-notification-banner-notice">
    By clicking “Accept All”, you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist
    in our marketing efforts.
  </div>

  <div class="cookies-notification-banner-button-container">
    <button
      class="btn mc-btn-primary mc-accept-close-btn"
      (click)="acceptCookies()"
      data-hook="cookies-notification-banner-button"
      data-testid="btn-accept-all"
    >
      Accept All
    </button>

    <button
      class="btn mc-btn-primary mc-accept-close-btn"
      (click)="rejectCookies()"
      data-hook="cookies-notification-banner-reject-button"
      data-testid="btn-reject-all"
    >
      Reject All Optional
    </button>

    <a
      [routerLink]="['/privacy-center', 'cookie-policy']"
      class="cookie-notification-more-info"
      target="_blank"
      rel="noopener noreferrer"
      data-hook="cookies-notification-banner-notice-link"
      data-testid="link-more-info-cookie"
    >
      More Info
    </a>
  </div>
</div>
